import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { SmartButton } from '../../common/SmartButton';
import PropTypes from 'prop-types';

import * as bookActions from '../../../actions/bookActions';
import * as revealActions from '../../../actions/revealActions';
import * as accountActions from '../../../actions/accountActions';
import * as bookApi from '../../../services/api/bookApi';
import Reveal from '../../common/reveal/Reveal';
import HeaderReveal from '../../common/reveal/HeaderReveal';
import AssignedClassrooms from './AssignedClassrooms';
import { Text } from './DesynchronizeComponents';

export const DESYNCHRONIZE_BOOK_REVEAL = 'desynchronizeBookReveal';

const parseLinkedClassrooms = response => {
  const data = response && response.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return [];
};

export class DesynchronizeBookReveal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.object,
    activeClassrooms: PropTypes.array,
    book: PropTypes.object,
    classroom: PropTypes.object,
    bookActions: PropTypes.object,
    unitId: PropTypes.string,
    openReveal: PropTypes.string
  };

  constructor(props, context) {
    super(props, context);
    this.state = { linkedClassrooms: [] };
    this.closeReveal = this.closeReveal.bind(this);
    this.handleDesyncBook = this.handleDesyncBook.bind(this);
  }

  componentDidMount() {
    this.loadLinkedClassrooms();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.openReveal !== this.props.openReveal && this.props.openReveal === DESYNCHRONIZE_BOOK_REVEAL) {
      this.loadLinkedClassrooms();
    }
  }

  loadLinkedClassrooms() {
    const { book, classroom } = this.props;
    if (!book?.activityId || !classroom?.sectionId) {
      return;
    }

    bookApi
      .getLinkedClassroomsForActivity(book.activityId, classroom.sectionId)
      .then(res => {
        this.setState({ linkedClassrooms: parseLinkedClassrooms(res) });
      })
      .catch(() => this.setState({ linkedClassrooms: [] }));
  }

  closeReveal() {
    this.props.revealActions.setOpenReveal();
  }

  handleDesyncBook() {
    const { book, classroom, bookActions } = this.props;
    bookActions.desynchronizeBook(classroom.id, book.id, classroom.sectionId, book.activityId);
    this.closeReveal();
  }

  renderContent() {
    const { activeClassrooms, unitId } = this.props;
    const { linkedClassrooms } = this.state;
    return (
      <div className="desynchronize-book-reveal-container">
        <div className="info-text">{I18n.t('bookContainer.desynchronizeInfo1')}</div>
        <AssignedClassrooms synchronizedClassrooms={linkedClassrooms} activeClassrooms={activeClassrooms} />
        <div className="info-text">
          <Text>{I18n.t('bookContainer.desynchronizeInfo2')}</Text>
          <Text>{I18n.t('bookContainer.desynchronizeInfo3')}</Text>
          {!unitId && (
            <Text>
              <b>{I18n.t('bookContainer.desynchronizeInfo4')}</b>
            </Text>
          )}
          <Text>{I18n.t('bookContainer.desynchronizeInfo5')}</Text>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Reveal id={DESYNCHRONIZE_BOOK_REVEAL} className="red">
        <HeaderReveal title={I18n.t('bookContainer.desynchronizeContent')} onCloseOnClick={this.closeReveal} />

        <div className="content">{this.renderContent()}</div>

        <div className="footer">
          <SmartButton onClick={this.closeReveal}>{I18n.t('common.cancel')}</SmartButton>
          <SmartButton danger onClick={() => this.handleDesyncBook()}>
            {I18n.t('bookContainer.desynchronize')}
          </SmartButton>
        </div>
      </Reveal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DesynchronizeBookReveal);

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    colors: state.theme.colors,
    book: state.book.book,
    classroom: state.classrooms.selectedClassroom.classroom,
    activeClassrooms: state.classrooms.activeClassrooms,
    unitId: state.router.location.query.unitId,
    openReveal: state.reveal.openReveal
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}
